import React from 'react';

import SimpleErrorBoundary from 'Jsx/Shared/ErrorBoundaries/Simple';

import { CountryPrefix } from 'Jsx/global.d.ts';

import TwoMillonBanner from '../components/TwoMillionBanner';
import RegularFooter from '../components/RegularFooter';
import MobileFooter from '../components/MobileFooter';

import { MobileFooterWrapper, RegularFooterWrapper } from './MainFooter.styles';

export type MainFooterProps = {
  countryPrefix: CountryPrefix | '';
  categories: Array<{
    name: string;
    order: number;
    url: string;
  }>;
  softwares: Array<{
    order: number;
    name: string;
    url: string;
  }>;
  customBgColor?: string;
  siteUrl?: string;
  isDark?: boolean;
};

const MainFooterRoot: React.FC<MainFooterProps> = ({
  categories,
  softwares,
  siteUrl = '',
  customBgColor = 'transparent',
  countryPrefix = '',
  isDark,
}) => {
  const categoriesFormatted = categories.map(category => ({
    ...category,
    label: category.name,
    link: `${siteUrl}${category.url}`,
  }));

  const softwaresFormatted = softwares
    .filter(software => software.name.includes('Adobe'))
    .map(software => ({
      ...software,
      label: software.name,
      link: `${siteUrl}${software.url}`,
    }));

  if (process.env.NODE_ENV === 'development') {
    if (!countryPrefix) {
      console.warn(
        'If you are in a page without internationalization(i18n) just ignore this warn. Hey! You are not passing the <countryPrefix> prop to the MainFooter component. We need this to create the urls!',
      );
    }
  }

  return (
    <SimpleErrorBoundary>
      <div className="pt-40 sm:pt-96 md:pt-120">
        <div
          className="pt-40 pb-32"
          id="MainFooter"
          style={{ backgroundColor: customBgColor }}
        >
          <MobileFooterWrapper>
            <MobileFooter
              siteUrl={siteUrl}
              customBgColor={customBgColor}
              countryPrefix={countryPrefix}
              categories={categoriesFormatted}
              softwares={softwaresFormatted}
              isDark={isDark}
            />
          </MobileFooterWrapper>
          <RegularFooterWrapper>
            <RegularFooter
              siteUrl={siteUrl}
              countryPrefix={countryPrefix}
              categories={categoriesFormatted}
              softwares={softwaresFormatted}
              isDark={isDark}
            />
          </RegularFooterWrapper>
        </div>
      </div>
    </SimpleErrorBoundary>
  );
};

// a dummy component to use the ErrorBoundary
export default MainFooterRoot;
